module.exports = __webpack_public_path__ + "img/vertical_4_2_9005.4f2f9603.png";